Vue.component('ppcarto-map', {
	template: '<div class="map"></div>',
	data() {
		return {
			settings: ppcarto.settings,
			map: {},
			layers: [],
			sections: [],
			tours: [],
			colors: ppcarto.settings.colors
		}
	},

	computed: {
		selectedSections() {
			return this.$store.getters.selectedSections
		},
		activeCategories() {
			return this.$store.getters.activeCategories
		},
		rome2rio() {
			return this.$store.getters.getRome2Rio;
		},
		activeroute() {
			let index;
			if (this.$store.getters.getRome2RioData.routes) {
				_.each(this.$store.getters.getRome2RioData.routes, (route, i) => {
					if (route.active) {
						index = i;
					}
				});
			}
			return index;
		},
		highlight() {
			return this.$store.getters.getHighlight;
		}
	},

	watch: {
		selectedSections(newSections, oldSections) {
			newSections.forEach(s => {
				if (!this.layers[s.key]) {
					this.layers[s.key] = this.setupLayer(s.key)
				} else {
					this.layers[s.key].show(this.map)
				}
			})

			_.difference(oldSections.map(s => s.key), newSections.map(s => s.key)).forEach(l => {
				this.layers[l].hide()
			});

		},
		activeCategories(newCategories, oldCategories) {
			newCategories.forEach(s => {
				this.layers[s.section].setFilter(s.categories)
			})
		},
		rome2rio(options) {

			if (options.visible == true) {
				this.showRome2Rio();
			} else {
				if(this.layers["r2r"]) {
					this.layers["r2r"].layer.clearLayers();
				}
			}
		},
		activeroute(index) {

			if (this.layers["r2r"]) {
				this.layers["r2r"].layer.clearLayers();
				this.layers["r2r"].layer.addLayer(this.layers["r2r"].routes[index])
				this.map.fitBounds(this.layers["r2r"].layer.getBounds())
			}
		},
		highlight(hl) {

			if (this.layers[hl.section]) {
				let item = _.find(this.layers[hl.section].data, d => {
					return d.feature.properties.se == hl.section && d.feature.properties.id == hl.id
				});
				let m = this.layers[hl.section].marker.getVisibleParent(item.marker);
				if (m && !m.isBouncing()) {
					m.setBouncingOptions({
						exclusive: true, // if this marker bouncing all others must stop
						elastic: false
					});
					m.bounce(2);
				}
			}
		}
	},

	methods: {
		icon_name(str) {
			var mapping = {
				"clear-day": "Sun",
				"clear-night": "Moon",
				"rain": "Cloud-Rain",
				"snow": "Cloud-Snow",
				"sleet": "Cloud-Drizzle",
				"wind": "Wind",
				"fog": "Cloud-Fog",
				"cloudy": "Cloud",
				"partly-cloudy-day": "Cloud-Sun",
				"partly-cloudy-night": "Cloud-Moon",
				"hail": "Cloud-Hail-Alt",
				"thunderstorm": "Cloud-Lightning"
			}
			var name = mapping[str];
			if (!name) {
				name = "Shades";
			}

			return name;
		},

		setupLayer(key) {
			let dotlayer = L.mapbox.featureLayer(null, {
				pointToLayer: (feature, latlon) => {
					return L.circleMarker(latlon, {
						radius: 3,
						stroke: false,
						fill: true,
						fillColor: this.colors[key],
						fillOpacity: 1
					});
				}
			}).addTo(this.map);

			let markerlayer = L.markerClusterGroup({
				//disableClusteringAtZoom: 1,
				chunkedLoading: true,
				maxClusterRadius: 44,
				polygonOptions: {
					stroke: false,
					fillColor: "#fc0"
				},
				iconCreateFunction: cluster => {
					return L.icon({
						iconUrl: `${this.settings.api.iconurl}cluster_${key}.svg`,
						iconSize: [22, 32],
						iconAnchor: [11, 32]
					});
				}
			}).addTo(this.map);

			let tourlayer = L.mapbox.featureLayer(null, {
				style: layer => {
					return {
						color: this.colors[key],
						weight: 1,
						opacity: 0.5
					}
				}
			}).addTo(this.map);

			let data = [];

			this.$store.commit('setLayerStatus', {key: key, status: 'loading'});

			this.$http.get(`${this.settings.api.baseurl}geo/${key}`).then((response) => {
				let geojson = response.data;
				dotlayer.setGeoJSON(geojson).setFilter( () => false);


				_.each(geojson["features"], (feature, index) => {
					if (!feature.geometry) {
						return;
					}
					let latlon = L.latLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
					let tt = L.tooltip({
						offset: [0, -40],
						direction: 'top',
						className: 'ppcarto-card-tooltip ' + key
					}).setContent(this.tooltipFor(feature));
					let pu = L.popup({
						offset: [0, -30],
						direction: 'top',
						className: 'ppcarto-card-tooltip ' + key,
						maxWidth: 175,
						closeButton: false
					}).setContent(this.popupFor(feature));
					let m = L.marker(latlon, {
						icon: this.iconFor(feature, key)
					}).bindTooltip(tt).bindPopup(pu);

					m.on('click', () => {
						m.closeTooltip()
					})

					const fd = {
						feature: feature,
						marker: m,
						tour: null,
						highlight(c) {

							if (this.tour) {
								if (c == "show") {
									this.tour.setStyle({
										weight: 4,
										opacity: 1
									})

								} else {
									this.tour.setStyle({
										weight: 1,
										opacity: 0.5
									})
								}
							}
						}
					};
					data.push(fd);

					m.on("mouseover", e => {
						fd.highlight("show");
					});

					m.on("mouseout", e => {
						fd.highlight("hide");
					});

				});
				//markerlayer.addLayers(_.map(data, f => f.marker));

				// if (_.filter(data, d => d.feature.properties.tour_id).length > 0) {
				//     if (!this.tours.features) {
				//         this.$http.get(`${this.settings.api.baseurl}geo/tour`).then((response) => {
				//             this.tours = response.data;
				//             setupTours()
				//         });
				//     } else {
				//         setupTours();
				//     }
				// }

			});

			//tourlayer = "xxx"
			let setupTours = () => {
				var paths = [];
				_.each(_.filter(data, d => d.feature.properties.tour_id), i => {
					_.each(this.tours.features, tour => {
						if (tour.properties.id == i.feature.properties.tour_id && tour.geometry.type == "LineString") {
							i.tourdata = tour;
							tour.properties.ca = i.feature.properties.ca;
							paths.push(tour);
						}
					})
				})
				// let paths = _.flatten(_.compact(_.map(data, d => d.tourdata)));
				tourlayer.setGeoJSON(paths).eachLayer((layer) => {
					_.each(_.filter(data, d => d.feature.properties.tour_id == layer.feature.properties.id), i => {
						i.tour = layer;
						layer.feature.properties.color = this.colors[key]
						layer.feature.properties.weight = 1;
						layer.feature.properties.opacity = 0.5;
					})
				});

			}

			/*
			let setupTours = (t) => {
			    _.each(_.filter(data, d => d.feature.properties.tour_id), i => {
			        i.tourdata = _.filter(this.tours.features, tour => tour.properties.id == i.feature.properties.tour_id)
			        _.defer( () => tourlayer.addLayer(i.tour));

			        _.each(i.tourdata, td => {

			            if (td.geometry.type == "Point" && td.properties.type == "end") {

			              let latlng = L.latLng(td.geometry.coordinates[1],td.geometry.coordinates[0])
			              let icon = L.icon({
			                iconUrl: `${this.settings.api.iconurl}${key}_end.svg`,
			                iconSize: [10, 10],
			                iconAnchor: [5, 5]
			              })
			              let m = L.marker(latlng, {icon: icon})

			              i.endmark = m;
			            }

			            if (td.geometry.type == "LineString") {

			                let tcase = L.mapbox.featureLayer(td);
			                tcase.setStyle({
			                    color: "#fff",
			                    weight: 6,
			                    opacity: 0,
			                    dashArray: ""
			                })
			                i.tour.addLayer(tcase);

			                let path = L.mapbox.featureLayer(td);
			                path.setStyle({
			                    color: this.colors[key],
			                    weight: 1,
			                    opacity: 0.5,
			                    dashArray: ""
			                })
			                i.tour.addLayer(path);

			                i.highlight = function(status) {
			                    if (status == "show") {

			                      i.tour.addLayer(i.endmark);

			                        tcase.setStyle({
			                            opacity: 1
			                        })
			                        path.setStyle({
			                            weight: 4,
			                            opacity: 1
			                        })

			                        //tourlayer.addLayer(i.tour);
			                    }

			                    if (status == "hide") {
			                        tcase.setStyle({
			                            opacity: 0
			                        })
			                        path.setStyle({
			                            weight: 1,
			                            opacity: 0.5
			                        })
			                        i.tour.removeLayer(i.endmark);

			                        //tourlayer.removeLayer(i.tour);
			                    }
			                }
			            }
			        });


			    });



			}
			*/
			this.$store.commit('setLayerStatus', {key: key, status: 'ready'});
			return {
				dots: dotlayer,
				marker: markerlayer,
				data: data,
				tour: tourlayer,
				store: this.$store,
				hide() {
					this.dots.remove()
					this.marker.remove()
					this.tour.remove()
				},
				show(map) {
					if (!map.hasLayer(this.dots)) {
						this.dots.addTo(map);
					}
					if (!map.hasLayer(this.marker)) {
						this.marker.addTo(map);
					}
					if (!map.hasLayer(this.tour)) {
						this.tour.addTo(map);
					}
				},
				setFilter(categories) {
					if (categories.length == 0) {

						// this.dots.setFilter(feature => true)
						// this.marker.clearLayers();
						// this.marker.addLayers(_.map(this.data, f => f.marker));
						// this.tour.setFilter(feature => true)

						this.dots.setFilter(feature => false)
						this.marker.clearLayers();
						//this.marker.addLayers(_.map(this.data, f => f.marker));
						this.tour.setFilter(feature => true)



					} else {
						this.store.commit('setLayerStatus', {key: key, status: 'filter'});
						this.dots.setFilter((feature) => _.intersection(feature.properties.ca, categories).length > 0)

						this.marker.clearLayers();
						this.marker.addLayers(_.map(_.filter(this.data, (i) => _.intersection(i.feature.properties.ca, categories).length > 0), f => f.marker));

						this.tour.setFilter((feature) => _.intersection(feature.properties.ca, categories).length > 0)
						this.tour.eachLayer(layer => {
							_.each(_.filter(data, d => d.feature.properties.tour_id == layer.feature.properties.id), i => {
								i.tour = layer;
							})
							layer.setStyle({
								color: layer.feature.properties.color
							})
						})
						this.store.commit('setLayerStatus', {key: key, status: 'done'});
						// this.tour.clearLayers();
						// let tours = _.filter(this.data, (j) => _.intersection(j.feature.properties.ca, categories).length > 0 && j.tour);
						//
						//  _.each(tours, f => {
						//    this.tour.addLayer(f.tour)
						//  })

					}
				}
			}
		},
		iconFor(feature, section) {
			let key = "default";
			if (feature.properties.ca && feature.properties.ca.length == 1) {
				key = feature.properties.ca[0];
			} else if (feature.properties.se.length == 1) {
				key = `cluster_${feature.properties.se[0]}_blank`;
			} else {
				let s = _.find(this.$store.getters.allSections, {
					key: section
				});
				let keys = _.intersection(s.categories.map(c => c.key), feature.properties.ca);
				if (keys.length == 1) {
					key = keys[0];
				} else {

					key = `cluster_${section}_blank`;
				}
			}
			if (feature.properties.se[0]) {
				key = `cluster_${feature.properties.se[0]}_blank`;
			}
			return L.icon({
				iconUrl: `${this.settings.api.iconurl}${key}.svg`,
				iconSize: [29, 44],
				iconAnchor: [15, 44]
			});
		},

		tooltipFor(feature) {
			let item = feature.properties;
			let detail = item.link ? `<a href="${item.link}" target="_blank" class="details">Details</a>` : '';
			let image = item.image ? `<div class="image" style="background-image: url(${item.image}"></div>` : '';
			let html = `<div class="ppcarto-card">
            <div class="image-wrapper">
              ${image}
            </div>
            <div class="info">
              <h5>${item.name}</h5>
            </div>
            <span class="loc">${item.town}</span>
          </div>`

			return html;
		},

		popupFor(feature) {
			let item = feature.properties;
			let detail = item.link ? `<a href="${item.link}" target="_blank" class="details">Details</a>` : '';
			let image = item.image ? `<div class="image" style="background-image: url(${item.image}"></div>` : '';

			let destination = { longName: `${item.name}, ${item.town}`, lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0] }

			let html = `<div class="ppcarto-card">
            <div class="image-wrapper">
              ${image}
            </div>
            <div class="info">
              <h5>${item.name}</h5>
            </div>
            <span class="loc">${item.town}</span>
            <div class="actions">
              ${detail}
              <a href="#" class="route" onclick="ppcarto.openTrip({ longName: '${item.name}, ${item.town}', lat: ${feature.geometry.coordinates[1]}, lng: ${feature.geometry.coordinates[0]} })">Anreise</a>
            </div>
          </div>`

			return html;
		},

		showRome2Rio() {

			const styles = {
				marker: {
					train: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					subway: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					car: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					plane: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					bus: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					shuttle: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					foot: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					ferry: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					taxi: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
					rideshare: {
						color: '#fff',
						fillColor: '#be2e7b',
						fillOpacity: 1,
						weight: 2,
						radius: 4
					},
				},
				path: {
					train: {
						color: '#684585',
						weight: 6
					},
					subway: {
						color: '#684585',
						weight: 6
					},
					car: {
						color: '#606060',
						weight: 6
					},
					plane: {
						color: '#73c6a6',
						weight: 6
					},
					bus: {
						color: '#cb782b',
						weight: 6
					},
					shuttle: {
						color: '#e0043b',
						weight: 6
					},
					foot: {
						color: '#606060',
						weight: 6
					},
					ferry: {
						color: '#70b7d2',
						weight: 6
					},
					taxi: {
						color: '#ebb11d',
						weight: 6
					},
					rideshare: {
						color: '#c02f3d',
						weight: 6
					},

				}
			}

			if (this.rome2rio.visible && this.rome2rio.from && this.rome2rio.to) {
				let params = {
					key: "T4zfoM0y",
					oName: this.rome2rio.from,
					dName: this.rome2rio.to,
					oPos: `${this.rome2rio.origin.lat},${this.rome2rio.origin.lng}`,
					dPos: `${this.rome2rio.destination.lat},${this.rome2rio.destination.lng}`,
					languageCode: 'en',
					currencyCode: 'eur'
				}

				this.$http.get(`https://free.rome2rio.com/api/1.4/json/Search`, {
					params: params
				}).then((response) => {
					//this.$http.get(`data-min.json`, {params: params}).then((response) => {
					let r2r = response.data;
					_.each(r2r.routes, r => {
						r.active = false
					});
					r2r.routes[0].active = true;

					this.$store.commit('setRome2RioData', r2r);

					if (this.layers["r2r"]) {
						this.layers["r2r"].layer.remove();
					}

					let layer = L.featureGroup().addTo(this.map);
					let routelayers = [];

					_.each(r2r.routes, route => {

						// let route = response.data.routes[4];
						//
						// console.log(route)

						let routeLayer = L.featureGroup()
						let pathLayer = L.featureGroup().addTo(routeLayer)
						let markerLayer = L.featureGroup().addTo(routeLayer).bringToFront();

						routelayers.push(routeLayer);

						_.each(route.segments, (segment, i) => {

							let vehicle = r2r.vehicles[segment.vehicle];
							let placeDep = r2r.places[segment.depPlace];
							let placeArr = r2r.places[segment.arrPlace];

							let stops = L.featureGroup();

							if (segment.path) {
								let p = L.Polyline.fromEncoded(segment.path);
								p.setStyle(styles.path[vehicle.kind])
								pathLayer.addLayer(p);

								let h = L.Polyline.fromEncoded(segment.path);
								h.setStyle({
									weight: 16,
									opacity: 0
								})
								pathLayer.addLayer(h);
								h.bringToFront();

								h.on('mouseover', e => {
									routeLayer.addLayer(stops);
									stops.eachLayer(l => l.closeTooltip())
									let closest = L.GeometryUtil.closestLayer(this.map, stops.getLayers(), e.latlng);
									if (closest) {
										closest.layer.openTooltip();
									}
								})

								h.on('mouseout', e => {
									routeLayer.removeLayer(stops);
								})

							} else {
								let latlngs = [
									[placeDep.lat, placeDep.lng],
									[placeArr.lat, placeArr.lng]
								]
								let p = L.polyline(latlngs);
								p.setStyle(styles.path[vehicle.kind])
								pathLayer.addLayer(p);
							}

							let ma = L.circleMarker([placeDep.lat, placeDep.lng], styles.marker[vehicle.kind])
							let tta = L.tooltip({
								permanent: true,
								opacity: 1,
								className: 'ppcarto-rome2rio-tooltip'
							}).setContent(`<img src="img/marker/rome2rio/${vehicle.kind}.svg">${placeDep.shortName}`);
							ma.bindTooltip(tta);
							markerLayer.addLayer(ma);

							let mb = L.circleMarker([placeArr.lat, placeArr.lng], styles.marker[vehicle.kind])
							let permanent = (route.segments.length - 1 == i);
							let ttb = L.tooltip({
								permanent: permanent,
								opacity: 1,
								className: 'ppcarto-rome2rio-tooltip'
							}).setContent(`<img src="img/marker/rome2rio/${vehicle.kind}.svg">${placeArr.shortName}`);
							mb.bindTooltip(ttb);
							markerLayer.addLayer(mb);

							_.each(segment.stops, stop => {
								let place = r2r.places[stop.place];
								let s = L.circleMarker([place.lat, place.lng], styles.marker[vehicle.kind])
								let t = L.tooltip({
									className: 'ppcarto-rome2rio-tooltip'
								}).setContent(`${place.shortName}`)
								s.bindTooltip(t)
								stops.addLayer(s);
							})

						})
					});

					this.layers["r2r"] = {
						layer: layer,
						routes: routelayers
					}

				});
			}
		}

	},

	mounted: function () {

		L.mapbox.accessToken = ppcarto.settings.mapbox.api_key;
		this.map = L.mapbox.map($('#ppcarto .map')[0], 'mapbox.outdoors', {
			zoomControl: true,
			//dragging: !L.Browser.mobile
		}).setView([46.73, 13.850278], 9);
		this.map.zoomControl.setPosition('bottomright');

		this.map.on("ready", e => {
			this.$store.commit('setBoundingBox', this.map.getBounds());
		})

		this.map.on('moveend', e => {
			this.$store.commit('setBoundingBox', this.map.getBounds());
		});

		let scope = this;

		// let weatherLayer = L.mapbox.featureLayer(null, {
		//     pointToLayer(feature, latlon) {
		//         let icon = L.icon({
		//             iconUrl: 'https://ppcb.pixelpoint.biz/weather/' + scope.icon_name(feature.properties.weather.icon) + '.svg',
		//             iconSize: [88, 88],
		//             iconAnchor: [44, 44],
		//             className: 'weather'
		//         });
		//
		//         let popup = L.popup({
		//             className: "weather__popup",
		//             closeButton: false,
		//             offset: [0, -18],
		//             maxWidth: "500"
		//         }).setContent(`<div class="weather__popup__temp">${ Math.round(feature.properties.weather.temperature) }°</div><div class="weather__popup__desc">${ feature.properties.weather.summary }</div>`)
		//
		//         let m = L.marker(latlon, {
		//             icon: icon
		//         }).bindPopup(popup);
		//         return m;
		//     }
		// }).loadURL(`${this.settings.api.baseurl}/region/geojson`).addTo(this.map);
		//
		// this.layers.push(weatherLayer);
	}
});
